import { CreatorNotesApiService, CreatorNotesDto } from '@api'
import { attach, createEffect, createStore, sample } from 'effector'
import { matchPath } from 'react-router'

import { Pages } from '@/consts/routes'
import { handleError } from '@/utils/error'

import { $creatorId } from './creators'
import { initializeApp } from './init'
import { $currentPage } from './router'
import { toast } from './toasts'

export const getCreatorNotesFx = attach({
  name: 'get creator notes',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (_: void, { creatorId }) => ({
    creatorId: creatorId!,
  }),
  effect: createEffect(CreatorNotesApiService.getCreatorNotes),
})

getCreatorNotesFx.failData.watch((error) => {
  handleError(
    error,
    'Something went wrong while getting creator notes',
    getCreatorNotesFx,
  )
})

export const $creatorNotes = createStore<CreatorNotesDto | null>(null).on(
  getCreatorNotesFx.doneData,
  (_, notes) => notes,
)

export const updateCreatorNotesFx = attach({
  name: 'update creator notes',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (notes: string, { creatorId }) => ({
    creatorId: creatorId!,
    requestBody: { notes },
  }),
  effect: createEffect(CreatorNotesApiService.updateCreatorNotes),
})

updateCreatorNotesFx.doneData.watch(() => {
  toast.success('Creator notes updated successfully')
})

updateCreatorNotesFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while updating creator notes')
})

export const $creatorNotesUpdating = updateCreatorNotesFx.pending

sample({
  clock: updateCreatorNotesFx.done,
  target: getCreatorNotesFx,
})

sample({
  clock: [initializeApp, $currentPage],
  source: { path: $currentPage },
  filter: ({ path }) => {
    return !!matchPath(Pages.CHATTING_UI, path)
  },
  target: getCreatorNotesFx,
})
